// src/lib/firebase.js
// ─────────────────────────────────────────────────────────
// ISTRUZIONI SETUP:
// 1. Vai su https://console.firebase.google.com
// 2. Crea un nuovo progetto (es. "<img src="/garagememo-logo.svg" alt="GarageMemo" style={{height: '60px'}} />-auto-moto")
// 3. Aggiungi un'app Web
// 4. Copia le credenziali qui sotto
// 5. Abilita: Authentication (Email/Password), Firestore, Storage
// ─────────────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            "AIzaSyC5high7TG787yc6gHtPqgys1K8HIJBWnw",
  authDomain:        "garagememo-92db5.firebaseapp.com",
  projectId:         "garagememo-92db5",
  storageBucket:     "garagememo-92db5.firebasestorage.app",
  messagingSenderId: "297734397473",
  appId:             "1:297734397473:web:6e79b6690b0ef4f96ecd60",
  measurementId:     "G-STQ4X0TZNJ"
};

const app       = initializeApp(firebaseConfig);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const analytics = getAnalytics(app);
export default app;
